import trips from './list/sagas'
import downloadTrips from './download/sagas'

export default [trips, downloadTrips]
